import { useGetMerchantProfile } from "../../hooks/queries/useMerchantQueries";
import { useDisableApi } from "../../hooks/queries/useMerchantOpenApiQueries";
import ApiAccessCard from "./components/cards/ApiAccessCard";
import ApiCredentialsCard from "./components/cards/ApiCredentialsCard";
import CallbackUrlCard from "./components/cards/CallbackUrlCard";
import ApiDocumentationCard from "./components/cards/ApiDocumentationCard";
import DeveloperPageSkeleton from "./components/DeveloperPageSkeleton";
import FetchFeedback from "../ui/CustomFetchFeedback/CustomFetchFeedback";

export default function DeveloperPage() {
  const {
    data: profile,
    isLoading,
    isError,
    refetch,
  } = useGetMerchantProfile();
  const { mutate: disableApi, isPending: isDisabling } = useDisableApi();

  if (isLoading) return <DeveloperPageSkeleton />;

  if (isError)
    return (
      <div className="flex min-h-[80vh] items-center justify-center">
        <FetchFeedback
          message="Failed to load developer settings. Please try again."
          onRetry={refetch}
          fullHeight={false}
        />
      </div>
    );
  const apiEnabled = profile?.apiEnabled ?? false;

  return (
    <div className="flex flex-col gap-6 p-4 md:p-6">
      <ApiAccessCard
        apiEnabled={apiEnabled}
        disableApi={disableApi}
        isDisabling={isDisabling}
      />

      <div
        className={
          apiEnabled ? "" : "pointer-events-none select-none opacity-50"
        }
      >
        <div className="flex flex-col gap-6">
          <ApiCredentialsCard key={String(apiEnabled)} apiEnabled={apiEnabled} isDisabling={isDisabling} />
          <CallbackUrlCard apiEnabled={apiEnabled} isDisabling={isDisabling} />
        </div>
      </div>

      <ApiDocumentationCard />
    </div>
  );
}
